import React from 'react';

import { CashbackInfo, CashbackLevel } from '../../../../../models';
import { getRewardsLevelColor } from '../../../../../helpers';
import { RewardsLevel } from './level';

interface RewardsDetailedPopupProgressTabProps {
  currency: string;
  cashbackInfo: CashbackInfo;
  onClaimClick: (level: CashbackLevel) => void;
  onInfoClick: (level: CashbackLevel) => void;
}

export const RewardsDetailedPopupProgressTab: React.FC<RewardsDetailedPopupProgressTabProps> = ({ cashbackInfo, currency, onClaimClick, onInfoClick }) => {
  const { levels, currentLevel, remainingBudgetAmount, budgetExhausted, claimLimitExceeded } = cashbackInfo;
  return (
    <div className="rewards-body">
      {
        levels.map((level, index) => {
          // 1. Budget check logic (ignoring isClaimed here since we handle it below)
          const isBudgetLessThanLevelReward = budgetExhausted || (remainingBudgetAmount !== null && remainingBudgetAmount < level.rewardAmount);

          // 2. Standard restriction rules for locked/unreached levels
          const isLockedLayout = level.level > currentLevel || isBudgetLessThanLevelReward;

          // 3. Absolute condition: If it's already finished or claimed, do NOT disable it
          const isFinishedOrClaimed = level.isClaimed;
          const isDisabled = isLockedLayout && !isFinishedOrClaimed;
          return (
            <RewardsLevel
              data={level}
              key={level.id}
              currency={currency}
              color={getRewardsLevelColor(index, levels.length)}
              disabled={isDisabled}
              onClaimClick={() => onClaimClick(level)}
              onInfoClick={() => onInfoClick(level)}
              active={level.level === currentLevel && !claimLimitExceeded}
            />
          )
        })
      }
    </div>
  );
};
